import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { OrderAuditTrailEvent } from '@ov-suite/models-order';
import { FeatureKey } from '@ov-suite/helpers-shared/lib/feature.enum';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: OrderAuditTrailEvent,
      createTitle: 'Order Audit Trail Events',
      route: ['order-events'],
      tableTitle: 'Order Events',
      hideAdd: true,
      hideImport: true,
      hideEditDelete: true,
      permissionId: FeatureKey.RESOURCES,
      defaultOrderColumn: 'timestamp',
      defaultOrderDirection: 'DESC',
    }),
  ],
})
export class OrdersAuditTrailEventModule {}
